import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import * as api from '../../../api/educentialApi';
import AccommodationDashboard from './AccommodationDashboard';

const AccommodationServiceRoutes = () => {
  const [enrolled, setEnrolled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkEnrollment();
  }, []);

  const checkEnrollment = async () => {
    try {
      const status = await api.getServiceStatus('accommodation');
      setEnrolled(status.enrolled);
      
      if (!status.enrolled) {
        await api.enrollInService('accommodation');
        setEnrolled(true);
      }
    } catch (err) {
      console.error('Enrollment check failed:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route index element={<AccommodationDashboard />} />
    </Routes>
  );
};

export default AccommodationServiceRoutes;
